<script setup lang="ts">
import { Level, Sex } from '~/stores/game';
import type { TaskType } from '~/types/tasks';

const props = defineProps<{
  task?: TaskType | null;
}>();

const { t } = useI18n();

// TODO(game_level_and_sex): дублирование что не очень хорошо
const stringLevel = computed(
  () =>
    ({
      [Level.easy]: t('levels.0'),
      [Level.average]: t('levels.1'),
      [Level.hot]: t('levels.2'),
    })[(props.task?.level as Level) || Level.easy],
);
const stringSex = computed(
  () =>
    ({
      [Sex.girl]: t('for_girl'),
      [Sex.boy]: t('for_boy'),
    })[(props.task?.target || Sex.boy) as Sex],
);
</script>

<template>
  <div class="gameView">
    <Head>
      <Title>
        {{
          t('meta.game.title', {
            sex: stringSex,
            id: props.task?.id,
            level: stringLevel.toLowerCase(),
          })
        }}
      </Title>

      <template v-if="props.task">
        <Meta name="description" :content="props.task.content || t('media_only_content')" />
        <Meta
          property="og:title"
          :content="
            t('meta.game.title', {
              sex: stringSex,
              id: props.task?.id,
              level: stringLevel.toLowerCase(),
            })
          "
        />
        <Meta property="og:description" :content="props.task.content || t('media_only_content')" />
      </template>
    </Head>

    <GameBackground />
    <div class="page-overflow-7" />

    <slot />
  </div>
</template>

<i18n src="~/locales/meta.yaml"></i18n>
<i18n>
en:
  levels:
    - Easy
    - Average
    - Hot
  for_boy: boy
  for_girl: girl
  media_only_content: Repeat the steps as in the image below.

ru:
  levels:
    - Легкий
    - Средний
    - Горячий
  for_boy: парня
  for_girl: девушки
  media_only_content: Повторите действия как на изображении ниже.

de:
  levels:
    - Einfach
    - Durchschnitt
    - Heiß
  for_boy: Kerl
  for_girl: Mädchen
  media_only_content: Wiederholen Sie die Schritte wie im Bild unten.

es:
  levels:
    - Fácil
    - Promedio
    - Caliente
  for_boy: chico
  for_girl: chicas
  media_only_content: Repita los pasos como en la imagen de abajo.

fr:
  levels:
    - Facile
    - Moyenne
    - Chaud
  for_boy: gars
  for_girl: filles
  media_only_content: Répétez les étapes comme dans l'image ci-dessous.
</i18n>

<style lang="scss">
.gameView {
  --game-navigation-height: 64px;
  --game-navigation-desktop-scale: 1.2;

  padding: calc(16px + var(--header-height)) 16px calc(16px + var(--game-navigation-height));
  flex: 1;
  width: 100%;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  align-items: center;
  position: relative;

  @media (min-width: 1024px) {
    padding-bottom: calc(var(--game-navigation-desktop-scale) * var(--game-navigation-height) + 16px);
  }

  &__background {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    top: 0;
    left: 0;
  }
}
</style>
